module.exports = __webpack_public_path__ + "img/TK.3daf10e5.svg";